export default __webpack_public_path__ + "static/md-4d08e48ef4cfb7c192dc4a833ededb93.svg";